import { render, staticRenderFns } from "./ProvidersIcon.vue?vue&type=template&id=2038d9de"
import script from "./ProvidersIcon.vue?vue&type=script&lang=js"
export * from "./ProvidersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports